import { appPermissions } from '@/libs/auth/permissions/appPermissions';
import { beforeEnterCheckPermission } from './utils/routePermissions';

export default [
  {
    name: 'pages',
    path: '/pages',
    component: () => import('@/views/pages/Page.vue'),
    meta: {
      title: 'المحتوى الثابت',
    },
    beforeEnter(to, from, next) {
      const { has, redirectTo } = beforeEnterCheckPermission(
        appPermissions.pages,
      );
      if (has) return next();
      else return next(redirectTo);
    },
  },
];
